import { render, staticRenderFns } from "./Noona.vue?vue&type=template&id=0a35eb31&scoped=true"
import script from "./Noona.vue?vue&type=script&lang=js"
export * from "./Noona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35eb31",
  null
  
)

export default component.exports